import { jsPDF } from "jspdf";
import "jspdf-autotable";

// We need a font that supports Cyrillic. 
// Since we can't easily bundle a large base64 string, we'll try to fetch it or use a default one if mostly english? 
// No, the user definitely uses Russian.
// Best approach for a coding agent with file size limits: 
// Use a standard font and transliterate ONLY if we absolutely can't get a font? 
// No, let's try to fetch a font from a public CDN if possible, or use a minimal base64.
// Actually, standard jsPDF does NOT support UTF-8 without a custom font. 
// Let's use a helper that loads a font from a URL.

export const loadFonts = async (doc) => {
  try {
    // Using a CDN for Roboto (supports Cyrillic)
    const fontUrl = "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf";
    const response = await fetch(fontUrl);
    const blob = await response.blob();
    const reader = new FileReader();
    
    return new Promise((resolve) => {
      reader.onloadend = () => {
        const base64data = reader.result.split(",")[1];
        doc.addFileToVFS("Roboto-Regular.ttf", base64data);
        doc.addFont("Roboto-Regular.ttf", "Roboto", "normal");
        doc.setFont("Roboto");
        resolve();
      };
      reader.readAsDataURL(blob);
    });
  } catch (e) {
    console.error("Font load error:", e);
    // Fallback?
  }
};

export const generatePDF = async (stat) => {
  const doc = new jsPDF();
  
  await loadFonts(doc);

  // If font loading failed, this might show garbage for Cyrillic, 
  // but it's the best we can do without a huge local file.
  
  // Title
  doc.setFontSize(18);
  doc.text("ZD GOLF TEAM", 105, 20, { align: "center" });
  
  doc.setFontSize(12);
  doc.text(`Игрок: ${stat.user_name}`, 20, 35);
  doc.text(`Поле: ${stat.course_name}`, 20, 42);
  doc.text(`Дата: ${stat.date}`, 20, 49);
  
  // Totals
  const t = stat.totals || {};
  const summary = [
    `Score: ${t.total_score || 0} (${(t.total_score || 0) - (t.total_par || 72)})`,
    `Putts: ${t.total_putts || 0}`,
    `Fairway: ${t.fairway_hits || 0}/${t.fairway_total || 14}`,
    `GIR: ${t.gir_hits || 0}/${t.gir_total || 18}`
  ];
  
  doc.text(summary.join("   |   "), 20, 60);
  
  if (stat.comments) {
    doc.text(`Комментарий: ${stat.comments}`, 20, 70);
  }

  // Table
  const tableData = stat.holes.map(h => [
    h.hole,
    h.par,
    h.total || "-",
    h.putts || "0",
    h.fairway === true ? "V" : h.fairway === false ? "X" : "-",
    h.green_regulation ? "V" : "-",
    h.chip || "0",
    h.bunker || "0",
    h.pitching || "0",
    h.up_and_down || "0"
  ]);

  doc.autoTable({
    startY: 80,
    head: [["#", "Par", "Score", "Putt", "FW", "GIR", "Chip", "Bunk", "Pitch", "U&D"]],
    body: tableData,
    styles: { font: "Roboto", fontSize: 9 },
    headStyles: { fillColor: [40, 100, 60] }
  });

  doc.save(`stats_${stat.date}.pdf`);
};
